import React, { Component } from "react";
import { connect } from 'react-redux';
import AppContent from './app'
import { GET_STUDIO_APPS_FROM_API, studioApps } from '../../../../../../../actions/sceneActions'
import { useParams } from "react-router-dom";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";

const UpdateApps = (props) => {
    const param = useParams();
    return <UA param={param} {...props} />
}
class UA extends Component {
    state = {
        apps: [],
        item: null
    }
    componentDidMount() {
        GET_STUDIO_APPS_FROM_API().then((layoutResponse) => {
            if (layoutResponse.data) {
                const { apps } = layoutResponse.data;
                this.setState({ apps }, () => this.props.studioApps(this.state.apps))

                setTimeout(() => {
                    this.onLoadApps();
                }, 1000);
            }
        })
            .catch((error) => {
                console.log("LAYOUT ISSUE", error)
            });
    }

    onLoadApps = () => {

        const { history, apps, param } = this.props;
        const { appID, contentMixId,wallId, positionID } = param;

        if (apps && apps.apps && apps.apps.length > 0) {
            const data = apps.apps.filter((item) => item.id == appID)
            if (data && data[0]) {
                this.setState({ item: data[0] })
            }
        }
        else if (this.state.apps && this.state.apps.length > 0) {
            const data = this.state.apps.filter((item) => item.id == appID)
            if (data && data[0]) {
                this.setState({ item: data[0] })
            }
        }
        else history(`/studio/${wallId}/apps/${contentMixId}/${positionID}`)
    }

    render() {
        const { match } = this.props;
        const { item } = this.state;

        return item && Object.keys(item) && Object.keys(item).length && <>
            <NavigationHeader name={item.name} backToNavigation={`/studio/${match.params.wallId}`} />
            <AppContent {...item} {...this.props} />
        </>;
    }
}

const mapStateToProps = state => {
    return {
        apps: state.apps
    }
}
const mapDispatchToProps = dispatch => {
    return {
        studioApps: (data) => dispatch(studioApps(data)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(UpdateApps);